import React from 'react'
import { Tooltip, Typography, withStyles } from '@material-ui/core'
import { Icon } from '@iconify/react'
import { CoreButton, CoreIconButton } from 'src/components/core'
import styles from './styles'

const PreviewHeader = props => {
  const {
    handleCloseModal,
    setHeight,
    setWidth,
    setType,
    type,
    classes,
  } = props
  return (
    <div className={classes.headerContainer}>
      <div className={classes.previewSection}>
        <Icon icon="mdi-light:eye" style={styles.eyeIcon} />
        <Typography style={styles.previewText}>
          You are in the preview mode
        </Typography>
      </div>
      <div className={classes.deviceSection}>
        <Tooltip title="Desktop">
          <CoreIconButton
            variant="text"
            color={type == 'desktop' ? 'primary' : 'secondary'}
            size="small"
            onClick={() => {
              setWidth('100%')
              setHeight('100%')
              setType('desktop')
            }}
            style={{
              backgroundColor:
                type == 'desktop' ? 'rgba(1, 95, 251, 0.1)' : 'transparent',
            }}
          >
            <Icon icon="proicons:tv" />
          </CoreIconButton>
        </Tooltip>
        <Tooltip title="Tablet">
          <CoreIconButton
            variant="text"
            color={type == 'tablet' ? 'primary' : 'secondary'}
            size="small"
            style={{
              backgroundColor:
                type == 'tablet' ? 'rgba(1, 95, 251, 0.1)' : 'transparent',
            }}
            onClick={() => {
              setWidth('1133px')
              setHeight('774px')
              setType('tablet')
            }}
          >
            <Icon icon="proicons:tablet" />
          </CoreIconButton>
        </Tooltip>
        <Tooltip title="Mobile">
          <CoreIconButton
            variant="text"
            color={type == 'mobile' ? 'primary' : 'secondary'}
            size="small"
            style={{
              backgroundColor:
                type == 'mobile' ? 'rgba(1, 95, 251, 0.1)' : 'transparent',
            }}
            onClick={() => {
              setWidth('375px')
              setHeight('812px')
              setType('mobile')
            }}
          >
            <Icon icon="proicons:phone" />
          </CoreIconButton>
        </Tooltip>
      </div>
      <div className={classes.closeSection}>
        <CoreButton
          endIcon={<Icon icon="eva:close-outline" />}
          color="secondary"
          variant="text"
          onClick={handleCloseModal}
        >
          Close preview
        </CoreButton>
      </div>
    </div>
  )
}

export default withStyles(styles)(PreviewHeader)
